import { AuxiliaryComponent, DB_COLLECTION_NAMES } from "@constants";
import { DocumentActions } from "../firestoreHookTypes";
import { useGetDocument } from "../useGetDocument";

function useGetAuxiliaryComponent(
  componentId: string,
): [AuxiliaryComponent | null, DocumentActions] {
  const [auxComponent, auxComponentActions] =
    useGetDocument<AuxiliaryComponent>(
      DB_COLLECTION_NAMES.AUXILIARY_COMPONENTS,
      componentId,
    );
  if (module) return [auxComponent, auxComponentActions];
  return [
    null,
    {
      update: () => Promise.resolve(),
      delete: () => Promise.resolve(),
    },
  ];
}

export { useGetAuxiliaryComponent };
